import store from '@/store'
import Toastify from '@/plugins/toastify'
import lang from '@/plugins/lang'
import { actionsOnMessage  } from '@/plugins/push-notification'
import * as serviceChat from './service-chat'

const elementCount = {
    add(el) {
        if (!el) {
            return
        }

        let value = parseInt(el.textContent || 0) + 1

        if (value !== 0) {
            el.classList.remove('d-none')
        }

        el.textContent = `${value < 10 ? '0' : ''}${value}`
    },

    remove(el) {
        if (!el) {
            return
        }

        let i = parseInt(el.textContent || 0) - 1

        let value = i < 0 ? 0 : i

        el.textContent = `${value < 10 ? '0' : ''}${value}`

        if (value === 0) {
            el.classList.add('d-none')
        }
    }
}

function newUserNotification(payload, fireNotify = true) {
    const userNotified = payload.data.add_user_notify === '1'

    if (userNotified) {
        let icon = document.querySelector('.topnav-menu .notification-list .noti-icon-badge')

        elementCount.add(icon)
    }

    if (fireNotify) {
        const title = payload.data.title || payload.notification?.title || lang.t('toast:default_notification.title')
        const text = payload.data.body || payload.notification?.body || lang.t('toast:default_notification.text')
        const destination = payload.data.link ?? (userNotified ? `/${store().prefixUrl}/user/notifications` : undefined)

        Toastify({
            title,
            text,
            destination,
            duration: payload.notification?.requireInteraction ? 0 : 10000
        }).showToast();
    }
}

let menuServiceChat = {
    getElement(nameClass = '') {
        return document.querySelector(`.main-sidebar .menu-service_chat${nameClass} .badge`)
    },

    add (nameClass) {
        elementCount.add(this.getElement())
        elementCount.add(this.getElement('_' + nameClass))
    },

    remove (nameClass) {
        elementCount.remove(this.getElement())
        elementCount.remove(this.getElement('_' + nameClass))
    }
}

let userNotifications = {
    // -------------------------- Service Chat --------------------------/

    createdRequestServiceChat(payload) {
        newUserNotification(payload, false)

        menuServiceChat.add('waiting')
    },

    customerIsWaitingServiceChat(payload) {
        serviceChat.createAnswerChatToast(parseInt(payload.data.chat_id), payload.notification)
    },

    answeredServiceChat(payload) {
        let notify = false

        if (payload.notification) {
            payload.notification.link = `/${store().prefixUrl}/service-chats`
            payload.notification.requireInteraction = true
            notify = true
        }

        newUserNotification(payload, notify)

        serviceChat.dismissRequestedChat(parseInt(payload.data.chat_id))

        menuServiceChat.remove('waiting')

        menuServiceChat.add('in_progress')
    },

    anotherAgentAnsweredServiceChat(payload) {
        serviceChat.dismissRequestedChat(parseInt(payload.data.chat_id))

        menuServiceChat.remove('waiting')
    },

    finishedInProgressServiceChat(payload) {
        newUserNotification(payload, !!payload.notification)

        menuServiceChat.remove('in_progress')
    },

    unansweredServiceChat(payload) {
        newUserNotification(payload, false)

        serviceChat.dismissRequestedChat(parseInt(payload.data.chat_id))

        menuServiceChat.remove('waiting')
    },

    agentTransferRequestedServiceChat(payload) {
        newUserNotification(payload, false)

        serviceChat.createAcceptTransferChatToast(parseInt(payload.data.chat_id), payload.notification)
    },

    cancelAgentTransferServiceChat(payload) {
        serviceChat.dismissTransferChat(parseInt(payload.data.chat_id))

        if (parseInt(payload.data.chat_agent_id) === store().auth.id) {
            Toastify({
                title: lang.t('page_user_notifications:serviceChat.refused_transfer_title'),
                text: lang.t('page_user_notifications:serviceChat.refused_transfer_text'),
            }).showToast();
        } else {
            Toastify({
                title: lang.t('page_user_notifications:serviceChat.canceled_transfer_title'),
                text: lang.t('page_user_notifications:serviceChat.canceled_transfer_text'),
            }).showToast();
        }
    },

    agentTransferAcceptedServiceChat(payload) {
        newUserNotification(payload)

        if (store().authType === 'agent') {
            menuServiceChat.remove('in_progress')
        }
    },

    newMessageServiceChat(payload) {
        if (`/${store().prefixUrl}/service-chats` !== window.location.pathname) {
            serviceChat.createReceivedMessage(parseInt(payload.data.chat_id), payload.notification)
        }
    },

    // -------------------------- Call --------------------------/

    createdCall: payload => newUserNotification(payload),
    editedCall: payload => newUserNotification(payload),
    archivedCall: payload => newUserNotification(payload),
    slaLimitExceededCall: payload => newUserNotification(payload),
    transferredCall: payload => newUserNotification(payload),

    // -------------------- Call Attendance --------------------/

    createdAttendance: payload => newUserNotification(payload),

    // -------------------------- Task --------------------------/

    createdTask: payload => newUserNotification(payload),
    editedTask: payload => newUserNotification(payload),
    archivedTask: payload => newUserNotification(payload),
}

export function register() {
    actionsOnMessage.add(userNotifications)
}
